import React, { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import registerImage from "../../Assets/ogac.jpg";
import { createUser } from "../../Api/Api";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const RegisterModal = ({ onClose }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = "Name is required";
    if (!form.email) errs.email = "Email is required";
    if (!form.mobile.match(/^\d{10}$/)) errs.mobile = "Enter a valid 10-digit number";
    if (!form.password) errs.password = "Password is required";
    if (form.password !== form.confirmPassword) errs.confirmPassword = "Passwords do not match";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const { name, email, password, mobile } = form;
      const response = await createUser({ name, email, password, mobile });

      toast.success("Registration successful!", { autoClose: 2000 });
      setTimeout(() => onClose(), 2000);
    } catch (error) {
      console.error("Registration failed:", error);
      const msg = error?.response?.data?.error || "Something went wrong. Please try again.";
      toast.error(msg);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center px-4">
      <ToastContainer />
      <div className="bg-white w-full max-w-3xl rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row">
        {/* Left Image */}
        <div className="hidden md:block md:w-1/2 bg-gray-100">
          <img
            src={registerImage}
            alt="Register"
            className="h-full w-full object-cover"
          />
        </div>

        {/* Right Content */}
        <div className="w-full md:w-1/2 p-6 relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-red-600"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>

          <h2 className="text-2xl font-bold text-[#0D004C] mb-6">Register</h2>
          <div className="space-y-4">
            <InputField
              label="Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              error={errors.name}
            />

            <InputField
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              type="email"
              error={errors.email}
            />

            <InputField
              label="Mobile Number"
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              type="tel"
              maxLength={10}
              error={errors.mobile}
            />

            <InputField
              label="Password"
              name="password"
              value={form.password}
              onChange={handleChange}
              type="password"
              error={errors.password}
            />

            <InputField
              label="Confirm Password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              type="password"
              error={errors.confirmPassword}
            />

            <button
              onClick={handleSubmit}
              className="w-full bg-[#0D004C] text-white py-2 rounded hover:bg-[#1a1460] transition"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// 🔧 Reusable input component for DRY code
const InputField = ({ label, name, value, onChange, type = "text", maxLength, error }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#0D004C]"
    />
    {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
  </div>
);

export default RegisterModal;
